import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeWithIdentitiesAndSubscribed } from '../../../graphql/queries/account';
import AlbumFolderPurchaseSelectAccountIdentities from '../../../components/purchase/album-folder-purchase/AlbumFolderPurchaseSelectAccountIdentities';
import { openModal, closeModal } from '../../../actions/modal-actions';
import { getPurchasedIdentitiesOnFolder } from '../../../util/account';
import { AlbumFolderWithIdentityAccess } from '../../../graphql/queries/album-folder';
import {
  onDeselectAlbumCustomPrint,
  onDeselectIdentity,
  onSelectAlbumCustomPrint,
  onSelectIdentity,
} from '../../../actions/discover-album-folder';
import { setActiveIdentity } from '../../../services/checkout/redux/checkoutActions';

const withUserData = graphql(MeWithIdentitiesAndSubscribed, {
  options: ({ match }) => ({
    variables: {
      albumFolderIds: [match.params.albumFolderId],
    },
  }),
  props: ({ data: { me, loading } = {}, ownProps: { albumFolder } }) => ({
    loading,
    accountId: me?.id,
    identities: me?.linked_identities?.records,
    purchasedIdentities: getPurchasedIdentitiesOnFolder(
      me,
      albumFolder?.root?.id,
    ),
    subscribedAlbumFolderIdentities:
      me?.subscribed_album_folder_identities?.records ?? [],
  }),
});

const withAlbumFolder = graphql(AlbumFolderWithIdentityAccess, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { albumFolder, loading } = {} }) => ({
    albumFolder,
    loading,
  }),
});

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  selectedIdentities: discoverAlbumFolder.identities,
  identity: discoverAlbumFolder.identities.find(
    identity => identity.id === discoverAlbumFolder.currentIdentityId,
  ),
  allowsJoinTypeSelection: discoverAlbumFolder.allowsJoinTypeSelection,
});

const mapDispatchToProps = {
  openModal,
  closeModal,
  onSelectIdentity,
  setActiveIdentity,
  onDeselectIdentity,
  onSelectAlbumCustomPrint,
  onDeselectAlbumCustomPrint,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withAlbumFolder,
  withUserData,
)(AlbumFolderPurchaseSelectAccountIdentities);
